import React, { useState } from 'react';
import '../styles/LawAppointment.css';

const LawAppointment = () => {
  const [formData, setFormData] = useState({
    name: '', address: '', email: '', mobile: '',
    consultationType: '', preferredLawyer: '', mode: '', selectedSlot: ''
  });
  const [confirmedSlot, setConfirmedSlot] = useState('');
  const [disabledSlots, setDisabledSlots] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [message, setMessage] = useState('');

  const morningSlots = [
    { slot: 'M1', label: 'Slot 1', time: '7:00 - 7:20 AM' },
    { slot: 'M2', label: 'Slot 2', time: '7:20 - 7:40 AM' },
    { slot: 'M3', label: 'Slot 3', time: '7:40 - 8:00 AM' },
    { slot: 'M4', label: 'Slot 4', time: '8:00 - 8:20 AM' },
    { slot: 'M5', label: 'Slot 5', time: '8:20 - 8:40 AM' },
    { slot: 'M6', label: 'Slot 6', time: '8:40 - 9:00 AM' }
  ];
  const eveningSlots = [
    { slot: 'E1', label: 'Slot 1', time: '6:30 - 6:50 PM' },
    { slot: 'E2', label: 'Slot 2', time: '6:50 - 7:10 PM' },
    { slot: 'E3', label: 'Slot 3', time: '7:10 - 7:30 PM' },
    { slot: 'E4', label: 'Slot 4', time: '7:30 - 7:50 PM' },
    { slot: 'E5', label: 'Slot 5', time: '7:50 - 8:10 PM' },
    { slot: 'E6', label: 'Slot 6', time: '8:10 - 8:30 PM' }
  ];

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSlotSelect = (slotId) => {
    if (disabledSlots.includes(slotId)) return;
    setFormData((prev) => ({ ...prev, selectedSlot: slotId }));
    setConfirmedSlot(slotId);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage('');

    if (!formData.selectedSlot) {
      alert('Please select a time slot.');
      return;
    }

    setIsLoading(true);

    try {
      const orderId = 'LAW-' + Date.now();

      const res = await fetch('/api/payment/create-session', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          name: formData.name,
          email: formData.email,
          mobile: formData.mobile,
          orderId,
          type: 'law',
          appointmentData: formData,
        }),
      });

      const data = await res.json();

      if (data?.payment_links?.web) {
        setDisabledSlots((prev) => [...prev, formData.selectedSlot]);
        window.location.href = data.payment_links.web;
      } else {
        throw new Error('Invalid payment link response');
      }
    } catch (error) {
      console.error('Payment Error:', error);
      setMessage('Something went wrong while initiating the payment. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };


  return (
    <div className="law-appointment-wrapper">
      <div className="law-content">
        <div className="law-terms-box">
          <div id="terms">
            <h3>📌 Terms and Conditions</h3>
            <ul>
              <li>
                Once the payment is completed, <strong style={{ color: 'red' }}>the amount will <u>not be refunded</u></strong> under any circumstances.
              </li>
              <li>
                Ensure all details entered are <strong>accurate</strong> before proceeding with the payment.
              </li>
              <li>
                Appointment slots are subject to <strong>availability</strong> and will be confirmed only after successful payment.
              </li>
              <li>
                Slot changes are allowed only in <strong>exceptional cases</strong> and based on slot availability.
              </li>
              <li>
                For technical issues or failures, contact <strong>support</strong> within <strong>24 hours</strong>.
              </li>
            </ul>
          </div>
        </div>
        <div className="law-form-card">
          {/* your form as is */}
          <form onSubmit={handleSubmit}>
            <input name="name" placeholder="Full Name" value={formData.name} onChange={handleChange} required />
            <input name="address" placeholder="Address" value={formData.address} onChange={handleChange} required />
            <input name="email" type="email" placeholder="Email" value={formData.email} onChange={handleChange} required />
            <input name="mobile" type="tel" placeholder="Mobile Number" value={formData.mobile} onChange={handleChange} required />
            <select name="consultationType" value={formData.consultationType} onChange={handleChange} required>
              <option value="">-- Select Consultation Type --</option>
              <option value="civil">Civil Law</option>
              <option value="criminal">Criminal Law</option>
              <option value="family">Family Law</option>
              <option value="property">Property Law</option>
            </select>
            <select name="preferredLawyer" value={formData.preferredLawyer} onChange={handleChange}>
              <option value="">-- Preferred Lawyer (Optional) --</option>
              <option value="lawyer-a">Adv. Anjali Mehta</option>
              <option value="lawyer-b">Adv. Ramesh Kumar</option>
              <option value="lawyer-c">Adv. Fatima Sheikh</option>
            </select>
            <select name="mode" value={formData.mode} onChange={handleChange} required>
              <option value="">-- Select Mode --</option>
              <option value="online">Online</option>
              <option value="offline">Offline</option>
            </select>
            <div className="time-slot-section">
              <div className="slots-group">
                <h4>Morning Slots</h4>
                <div className="slots">
                  {morningSlots.map(({ slot, label, time }) => (
                    <button
                      key={slot}
                      type="button"
                      className={`slot-button ${formData.selectedSlot === slot ? 'selected' : ''}`}
                      onClick={() => handleSlotSelect(slot)}
                      disabled={disabledSlots.includes(slot)}
                      title={time}
                    >
                      {label}
                    </button>
                  ))}
                </div>
              </div>
              <div className="slots-group">
                <h4>Evening Slots</h4>
                <div className="slots">
                  {eveningSlots.map(({ slot, label, time }) => (
                    <button
                      key={slot}
                      type="button"
                      className={`slot-button ${formData.selectedSlot === slot ? 'selected' : ''}`}
                      onClick={() => handleSlotSelect(slot)}
                      disabled={disabledSlots.includes(slot)}
                      title={time}
                    >
                      {label}
                    </button>
                  ))}
                </div>
              </div>
            </div>
            <p style={{ fontWeight: 'bold', marginTop: '8px', color: '#333' }}>Appointment Fee ₹100</p>
            <button type="submit" disabled={isLoading}>
              {isLoading ? 'Processing...' : 'Book Appointment'}
            </button>
            {message && <p className="error">{message}</p>}
            {/* inputs + selects + slots + button */}
          </form>
        </div>
      </div>
    </div>
  );
};

export default LawAppointment;
